<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div [class.isPrinting]="printService.isPrinting">
  <div class="row margin-bottom-10px" id="edit-link">
    <div class="col-md-12">
      <div class="card box-shadow-new-treatmentcycle border-left-et ">
        <div class="card-header wh-header border-bottom-1px padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
          <div class="row nav-link-hand margin-left-0px margin-right-0px background-new-et data-color-white">
            <div class="col-md-6 padding-right-0px">
              <label class="margin-bottom-0px font-size-16px font-weight-normal" id="et">
                <!--<i class="fas fa-circle light-gray-badge nav-link-hand  ">
                </i>-->
                ET
              </label>
            </div>
            <div class="col-md-6  padding-right-0px display-edit">
              <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
              <div class="row  margin-left-0px margin-right-0px" *ngIf="EmbryoTransferData2">
              
                <div class="offset-md-4 col-md-3" *ngIf="EmbryoTransferData2.ActivityStatus !=='Completed'">

                  <button class="btn actions-btn-prime float-right font-size-15px " type="button" (click)="EditEt()">
                    <i class="fas fa-pencil-alt"></i> ET
                  </button>
               
                </div>
                <div class="offset-md-6 col-md-2" *ngIf="EmbryoTransferData2.ActivityStatus =='Completed'">

                 
                  <a class="nav-link-hand education-navlink" title="Detail" (click)="EditEt()" >
      <span class="badge font-size-16px padding-right-0px"><i class="fa fa-info-circle"></i></span>
    </a>
                  
                </div>
                <div class="col-md-1 padding-right-0px">
                  <!--<a class="nav-link-hand education-navlink " title="print" (click)="printtransfer()">
      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
    </a>-->
                  <button type="button" class="btn actions-btn-prime float-right font-size-15px padding-right-0px padding-left-0px min-width-32px" (click)="printtransfer()"><i class="fa fa-print"></i></button>
                </div>

                <div class="col-md-1 padding-left-11px">
                  <!--<button type="button"
            class="btn  btn-sm drive-button3 background-primary border-all-secondary" id="FileUpload"
            name="upload">
      <i class="fas fa-plus font-size-11"></i>
    </button>-->
                  <button type="button" (click)="Top()"
                          class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                          name="upload">
                    <i class="fas fa-arrow-alt-circle-up color-green font-size-18px"></i>
                    <!--<i class="fas fa-long-arrow-alt-up font-size-11"></i>-->
                  </button>

                </div>
                <div class="col-md-1 padding-left-11px">
                  <button type="button" (click)="Bottom()"
                          class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                          name="upload" title="Goto Bottom">
                    <i class="fas fa-arrow-alt-circle-down color-green font-size-18px"></i>
                    <!--<i class="fas fa-long-arrow-alt-down font-size-11 "></i>-->
                  </button>
                </div>
              </div>




            </div>

          </div>
        </div>
        <div class="card-body padding-top-0px padding-left-0px padding-right-0px">
          <div class="row margin-top-10 margin-left-0px margin-right-0px">
            <div class="col-md-4 padding-left-15px padding-right-15px background-white">
              <div class="card  h-100 padding-left-10px">
                <div class="card-header wh-header header-new header-4 font-size-14 card-background-transparent color-ovulation">
                  <i class="fas fa-users"></i> Team
                </div>
                <div class="card-body padding-top-0px padding-left-8px padding-bottom-0px">
                  <!--<div class="row">
            <div class="col-md-12 margin-top-5px">
              <label class="font-size-12px margin-bottom-0px">Surgeon</label>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12 padding-left-12px">
              <label class="font-size-15px margin-bottom-0px color-cyan font-weight-bold "><img class="img-circle-30" src='dummy.jpg'> Dr.Asha</label>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="font-size-12px margin-bottom-0px">Asst.Surgeon</label>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12 padding-left-12px">
              <label class="font-size-15px margin-bottom-0px"><img class="img-circle-30" src='dummy.jpg'> Dr.Keisham</label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="font-size-12px margin-bottom-0px">Embryologist</label>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12 padding-left-12px">
              <label class="font-size-15px margin-bottom-0px"><img class="img-circle-30" src='dummy.jpg'> Dr.Madhu</label>
            </div>
          </div>-->
                  <div class="row margin-top-10">
                    <div class="col-md-4 ">
                      <img class="img-circle-30" src='dummy.jpg'>
                    </div>
                    <div class="col-md-6 padding-left-5px padding-right-0px">
                      <div class="row" *ngIf="EmbryoTransFerEndInfo">
                        <label class="margin-bottom-0px font-size-13px">Dr.{{EmbryoTransFerEndInfo.SurgeonName}}</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-0px font-size-11px">Surgeon</label>
                      </div>

                    </div>
                    <!--<div class="col-md-12 margin-top-5px">
              <label class="font-size-15px margin-bottom-0px color-cyan font-weight-bold "><img class="img-circle-30" src='dummy.jpg'> Dr.Asha</label>
              <div>
                <label class="font-size-12px margin-bottom-0px">Surgeon</label>
              </div>
            </div>-->

                  </div>
                  <div class="row margin-top-10">
                    <div class="col-md-4 ">
                      <img class="img-circle-30" src='dummy.jpg'>
                    </div>
                    <div class="col-md-6 padding-left-5px padding-right-0px">
                      <div class="row" *ngIf="EmbryoTransFerEndInfo">
                        <label class="margin-bottom-0px font-size-13px">Dr.{{EmbryoTransFerEndInfo.AsstSurgeonName}}</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-0px font-size-11px">Asst.Surgeon</label>
                      </div>

                    </div>
                    <!--<div class="col-md-12 margin-top-5px">
              <label class="font-size-15px margin-bottom-0px color-cyan font-weight-bold "><img class="img-circle-30" src='dummy.jpg'> Dr.Asha</label>
              <div>
                <label class="font-size-12px margin-bottom-0px">Surgeon</label>
              </div>
            </div>-->

                  </div>
                  <div class="row margin-top-10 margin-bottom-5px">
                    <div class="col-md-4 ">
                      <img class="img-circle-30" src='dummy.jpg'>
                    </div>
                    <div class="col-md-6 padding-left-5px padding-right-0px">
                      <div class="row" *ngIf="EmbryoTransFerEndInfo">
                        <label class="margin-bottom-0px font-size-13px">Dr.{{EmbryoTransFerEndInfo.EmbryologistName}}</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-0px font-size-11px">Embryologist</label>
                      </div>

                    </div>
                    <!--<div class="col-md-12 margin-top-5px">
              <label class="font-size-15px margin-bottom-0px color-cyan font-weight-bold "><img class="img-circle-30" src='dummy.jpg'> Dr.Asha</label>
              <div>
                <label class="font-size-12px margin-bottom-0px">Surgeon</label>
              </div>
            </div>-->

                  </div>
                </div>
              </div>

            </div>
            <div class="col-md-4 background-white">
              <div class="card  h-100">
                <div class="card-header wh-header header-new header-4 font-size-14 card-background-transparent color-team">
                  <i class="fas fa-users"></i> Anaesthetist Team
                </div>
                <div class="card-body padding-top-0px padding-left-8px padding-bottom-0px">
                  <div class="row margin-top-5px">
                    <div class="col-md-4 ">
                      <img class="img-circle-30" src='dummy.jpg'>
                    </div>
                    <div class="col-md-6 padding-left-5px padding-right-0px">
                      <div class="row" *ngIf="EmbryoTransFerEndInfo">
                        <label class="margin-bottom-0px font-size-13px">{{EmbryoTransFerEndInfo.AnesthesiologistName}}</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-0px font-size-11px">Anaesthesiologist</label>
                      </div>

                    </div>
                    <!--<div class="col-md-12 margin-top-5px">
              <label class="font-size-15px margin-bottom-0px color-cyan font-weight-bold "><img class="img-circle-30" src='dummy.jpg'> Dr.Asha</label>
              <div>
                <label class="font-size-12px margin-bottom-0px">Surgeon</label>
              </div>
            </div>-->

                  </div>
                  <div class="row">
                    <div class="col-md-12 margin-top-5px">
                      <label class="font-size-12px margin-bottom-0px">Anaesthesia</label>
                    </div>

                  </div>
                  <div class="row" *ngIf="EmbryoTransFerEndInfo">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px">{{EmbryoTransFerEndInfo.AnaesthesiaType}}</label>
                    </div>

                  </div>
                  <!--<div class="row">
            <div class="col-md-12">
              <label class="font-size-12px margin-bottom-0px">Anaesthesiologist</label>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12 padding-left-12px">
              <label class="font-size-15px margin-bottom-0px font-weight-bold color-cyan"><img class="img-circle-30" src='dummy.jpg'> Dr.Madhu</label>
            </div>
          </div>-->

                </div>
              </div>
            </div>
            <div class="col-md-4 background-white">
              <div class="card  h-100">
                <div class="card-header wh-header header-new header-4 font-size-14 card-background-transparent color-Schedule">
                  <i class="fas fa-clock"></i> Schedule
                </div>
                <div class="card-body padding-top-0px padding-left-8px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 margin-top-5px">
                      <label class="font-size-12px margin-bottom-0px">Planned Time </label>
                    </div>

                  </div>
                  <div class="row" *ngIf="EmbryoTransFerEndInfo">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-5px ">{{EmbryoTransFerEndInfo.TransferDate| date:'dd-MMM-yyyy'}},{{EmbryoTransFerEndInfo.TransferStartTime|date: 'mediumTime'}}</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Actual Time</label>
                    </div>

                  </div>
                  <div class="row" *ngIf="EmbryoTransFerEndInfo">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px color-cyan font-weight-bold ">{{EmbryoTransFerEndInfo.TransferEndDate| date:'dd-MMM-yyyy'}},{{EmbryoTransFerEndInfo.TransferEndTime|date: 'mediumTime'}}</label>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="row margin-top-10 margin-left-0px">
            <div class="col-md-4 padding-left-15px padding-right-15px background-white">
              <div class="card  h-100 padding-left-10px">
                <div class="card-header wh-header header-new header-4 font-size-14 card-background-transparent color-procedure">
                  Oocytes
                </div>
                <div class="card-body padding-top-0px padding-left-8px padding-bottom-0px">
                  <!--<div class="row">
            <div class="col-md-12 margin-top-5px">
              <label class="font-size-12px margin-bottom-0px">Surgeon</label>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12 padding-left-12px">
              <label class="font-size-15px margin-bottom-0px color-cyan font-weight-bold "><img class="img-circle-30" src='dummy.jpg'> Dr.Asha</label>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="font-size-12px margin-bottom-0px">Asst.Surgeon</label>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12 padding-left-12px">
              <label class="font-size-15px margin-bottom-0px"><img class="img-circle-30" src='dummy.jpg'> Dr.Keisham</label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="font-size-12px margin-bottom-0px">Embryologist</label>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12 padding-left-12px">
              <label class="font-size-15px margin-bottom-0px"><img class="img-circle-30" src='dummy.jpg'> Dr.Madhu</label>
            </div>
          </div>-->
                  <div class="row margin-top-5px">
                    <div class="col-md-6 ">
                      <label class="margin-bottom-0px font-size-13px">Frozen</label>
                    </div>
                    <div class="col-md-6 padding-left-0px text-align-right">
                      <!--<button type="button" class="btn btn-primary"><span class="badge">7</span></button>-->

                      <div class="badge badge-oocytes background-Frozen" *ngIf="FrozenCount">
                        {{FrozenCount}}
                      </div>
                    </div>
                    <!--<div class="col-md-12 margin-top-5px">
              <label class="font-size-15px margin-bottom-0px color-cyan font-weight-bold "><img class="img-circle-30" src='dummy.jpg'> Dr.Asha</label>
              <div>
                <label class="font-size-12px margin-bottom-0px">Surgeon</label>
              </div>
            </div>-->

                  </div>
                  <div class="row margin-top-5px margin-bottom-5px">
                    <div class="col-md-6 ">
                      <label class="margin-bottom-0px font-size-13px">Total</label>
                    </div>
                    <div class="col-md-6 padding-left-0px text-align-right">
                      <div class="badge badge-oocytes background-Total" *ngIf="TotalCount">
                        {{TotalCount}}
                      </div>


                    </div>
                    <!--<div class="col-md-12 margin-top-5px">
              <label class="font-size-15px margin-bottom-0px color-cyan font-weight-bold "><img class="img-circle-30" src='dummy.jpg'> Dr.Asha</label>
              <div>
                <label class="font-size-12px margin-bottom-0px">Surgeon</label>
              </div>
            </div>-->

                  </div>


                </div>
              </div>

            </div>

          </div>
          <div class="row margin-top-10" *ngIf="GradingModel=='Droplet Culture'">
            <div class="col-md-11 padding-right-0px padding-left-24px">
              <div class="card margin-left-10px">
                <div class="card-header color-Assign background-primary padding-top-0px padding-bottom-3px padding-left-3px padding-right-0px font-size-15px border-bottom-1px font-weight-normal">
                  Embryo Grading
                </div>
                <div class="card-body padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px">
                  <div class="table-component">
                    <div class="table-responsive">


                      <table class="table table-striped margin-left-zero width-50-new">
                        <thead class="">
                          <tr>
                            <th class="padding-top-4px padding-bottom-4px font-size-12px padding-left-0px">DOC &amp; Date  </th>

                            <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px"> Stage  </th>
                            <th class="min-width-0px padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Straw#</th>
                            <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Grade</th>
                            <th class="min-width-0px padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Transfer Count</th>
                            <!--<th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px"> Is Transferred</th>-->
                          </tr>
                        </thead>

                        <tbody class="table-body">
                          <tr *ngFor="let l of CurrentIvfCycleEmbryoTransferredController">

                            <td class="padding-top-4px padding-bottom-4px padding-right-0px padding-left-0px">
                              <div>[{{l.DOC}}]</div>
                              <div class="font-size-11px">{{l.TimeStamp| date:'MMM-dd-yyyy'}}</div>
                            </td>
                            <td class="padding-top-0px padding-bottom-0px">
                              {{l.Cellstage}}
                            </td>
                            <td class="padding-top-0px padding-bottom-0px text-align-center text-align-center">{{l.StrawNumber}}</td>
                            <td class="padding-top-0px padding-bottom-0px">{{l.Regrade1}}{{l.Regrade2}}</td>
                            <td class="padding-top-0px padding-bottom-0px text-align-center text-align-center">{{l.UsedCount}}</td>






                          </tr>



                        </tbody>

                      </table>

                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="row margin-top-10" id="Grad">
            <div class="col-md-12 padding-left-24px">
              <div class="card">
                <div class="card-header color-Assign background-primary padding-top-0px padding-bottom-3px padding-left-3px padding-right-0px font-size-15px border-bottom-1px font-weight-normal">
                  Grading Summary
                </div>
                <div class="card-body padding-top-0px padding-bottom-0px padding-right-0px">
                  <!--<div class="table-component overflow-x margin-bottom-0px margin-top-10">
            <div class="table-responsive overflow-x">


              <table class="table table-striped margin-left-zero">

                <thead class="">
                  <tr>


                    <th class="font-weight-normal td-padding-tb td-width-162px">Embryo Number</th>

                    <th class="font-weight-normal td-padding-tb">Grade ID</th>
                    <th class="font-weight-normal td-padding-tb">Symmetric</th>

                    <th class="font-weight-normal  td-padding-tb">Assymmetric</th>

                  </tr>

                </thead>
                <tbody class="table-body">
                  <tr>
                    <td class="td-padding-tb">3</td>
                    <td class="td-padding-tb">BNJ789</td>
                    <td class="td-padding-tb">Normal</td>
                    <td class="td-padding-tb">Normal</td>
                  </tr>
                  <tr>
                    <td class="td-padding-tb">3</td>
                    <td class="td-padding-tb">BNJ789</td>
                    <td class="td-padding-tb">Normal</td>
                    <td class="td-padding-tb">Normal</td>
                  </tr>
                  <tr>
                    <td class="td-padding-tb">3</td>
                    <td class="td-padding-tb">BNJ789</td>
                    <td class="td-padding-tb">Normal</td>
                    <td class="td-padding-tb">Normal</td>
                  </tr>
                </tbody>

              </table>
            </div>
          </div>-->
                  <div class="row" *ngIf="GradingModel=='Well Culture'">
                    <div class="col-md-3 border-all-1px margin-top-10 padding-left-0px padding-right-0px border-radius-4px margin-right-5px" *ngFor="let l of CurrentSingleWellCultureByCycleCodeController">
                      <div class="card">
                        <div class="card-header padding-top-5 padding-bottom-5px padding-right-0px padding-left-10px">
                          <label class="margin-bottom-0px font-size-15px">D{{GetMaxDOC(l)}}</label>
                        </div>
                        <div class="card-body padding-all-0px">
                          <img [src]='GetMaxImageUrl(l)' class="image-border-radius nav-link-hand" height="150px" width="167px" />
                        </div>
                        <div class="card-footer text-align-center padding-left-0px padding-right-0px padding-bottom-0px padding-top-0px background-card-footer">
                          <label class="margin-bottom-0px">{{GetMaxGrade(l)}}</label>
                        </div>
                      </div>
                      <!--<div class="row">
                <div class="col-md-12">
                  <label class="margin-bottom-0px">D5</label>
                </div>
              </div>
              <div class="row">
                <img src='Day-5-Embryo.jpg' class="image-border-radius nav-link-hand" height="150px" width="150px" />
              </div>
              <div class="row">
                <div class="col-md-12 text-align-center">
                  <label>AB</label>
                </div>


              </div>-->
                    </div>



                  </div>
                  <div class="row" *ngIf="GradingModel=='Droplet Culture'">
                    <div class="col-md-8">
                      <div class="card" *ngIf="SelectedpatientDetails">
                        <ivfembryogradingdroplet TitleText="Day1" DOC="1" [CycleCode]="CycleCode" mode="view" [CanLoadReport]='CanLoadReport'>

                        </ivfembryogradingdroplet>
                      </div>
                      <div class="card" *ngIf="SelectedpatientDetails">
                        <ivfembryogradingdroplet TitleText="Day2" DOC="2" [CycleCode]="CycleCode" mode="view" [CanLoadReport]='CanLoadReport'>

                        </ivfembryogradingdroplet>
                      </div>

                      <div class="card" *ngIf="SelectedpatientDetails">
                        <ivfembryogradingdroplet TitleText="Day3" DOC="3" [CycleCode]="CycleCode" mode="view" [CanLoadReport]='CanLoadReport'>

                        </ivfembryogradingdroplet>
                      </div>
                      <div class="card" *ngIf="SelectedpatientDetails">
                        <ivfembryogradingdroplet TitleText="Day4" DOC="4" [CycleCode]="CycleCode" mode="view" [CanLoadReport]='CanLoadReport'>

                        </ivfembryogradingdroplet>
                      </div>
                      <div class="card" *ngIf="SelectedpatientDetails">
                        <ivfembryogradingdroplet TitleText="Day5" DOC="5" [CycleCode]="CycleCode" mode="view" [CanLoadReport]='CanLoadReport'>

                        </ivfembryogradingdroplet>
                      </div>
                      <div class="card" *ngIf="SelectedpatientDetails">
                        <ivfembryogradingdroplet TitleText="Day6" DOC="6" [CycleCode]="CycleCode" mode="view" [CanLoadReport]='CanLoadReport'>

                        </ivfembryogradingdroplet>
                      </div>
                    </div>



                  </div>
                </div>
              </div>
            </div>
            <!--<div class="col-md-4">
      <div class="card card-border-styles h-100">
        <div class="card-header wh-header header-new header-4 font-size-14">
          Procedure Details
        </div>
        <div class="card-body padding-top-0px padding-left-8px padding-bottom-0px">
          <div class="row">
            <div class="col-md-12 margin-top-5px">
              <label class="font-size-12px margin-bottom-0px">Needle Used</label>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="font-size-15px margin-bottom-0px">Double Lumen</label>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="font-size-12px margin-bottom-0px">Route</label>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="font-size-15px margin-bottom-0px font-weight-bold color-cyan">Tv</label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="font-size-12px margin-bottom-0px">Complications</label>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="font-size-15px margin-bottom-0px">Nill</label>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <label class="font-size-12px margin-bottom-0px">Batch</label>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="font-size-15px margin-bottom-0px">BNJ789</label>
            </div>
          </div>
        </div>
      </div>
    </div>-->
          </div>
          <div class="row margin-top-10">
            <div class="col-md-12 padding-left-24px">
              <div class="card">
                <div class="card-header color-Assign background-primary padding-top-0px padding-bottom-3px padding-left-3px padding-right-0px font-size-15px border-bottom-1px font-weight-normal">
                  Transfer Details
                </div>
                <div class="card-body padding-top-0px padding-bottom-0px padding-right-0px">
                  <div class="row margin-top-10">
                    <!--<div class="col-md-4 padding-left-15px padding-right-15px">
              <div class="card card-border-styles h-100">
                <div class="card-header wh-header header-new header-4 font-size-14">
                  Method
                </div>
                <div class="card-body padding-top-0px padding-left-8px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 margin-top-5px">
                      <label class="font-size-12px margin-bottom-0px">Method Name</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px  font-weight-bold ">Clinical Touch</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Endometrium Thickness</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px ">8 mm</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Fragmentation</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px">Present</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Fragmentation(%)</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px">3</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Speculum Used</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px">Cusco's</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Technique</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px">After Loading</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Embryo Transfer</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px">Difficult</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Leaning of cervical Canal</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px">Media Cleaning of Cervical Canal</label>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="col-md-4">
              <div class="card card-border-styles h-100">
                <div class="card-header wh-header header-new header-4 font-size-14">
                  Media &amp; Catheter
                </div>
                <div class="card-body padding-top-0px padding-left-8px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 margin-top-5px">
                      <label class="font-size-12px margin-bottom-0px">Culture Media Used</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px">Cook</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Catheter Type</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px font-weight-bold color-cyan">Soft</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Catheter Used</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px">Rocket</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Blood on Catheter </label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px">Present</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 ">
              <div class="card card-border-styles h-100">
                <div class="card-header wh-header header-new header-4 font-size-14">
                  Observation
                </div>
                <div class="card-body padding-top-0px padding-left-8px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 margin-top-5px">
                      <label class="font-size-12px margin-bottom-0px">Reatined Embryos </label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px ">Present</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Retransfer</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px color-cyan font-weight-bold ">Done</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-12px margin-bottom-0px">Cervical Mucus</label>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="font-size-15px margin-bottom-0px color-cyan font-weight-bold ">Present</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>-->

                    <div class="col-md-6 border-right">
                      <div class="row">


                        <div class="col-md-6  text-align-right">
                          <label for="firstName" class="font-size-14px font-weight-700">Type Of Transfer </label>
                        </div>:
                        <div class="col-md-5 text-align-left" *ngIf="EmbryoTransFerEndInfo">


                          <label class="font-size-14px">{{EmbryoTransFerEndInfo.TypeOfTransfer}}</label>
                        </div>




                      </div>
                      <div class="row">


                        <div class="col-md-6  text-align-right">
                          <label for="firstName" class="font-size-14px font-weight-700">Culture Media Used </label>
                        </div>:
                        <div class="col-md-5 text-align-left" *ngIf="EmbryoTransFerEndInfo">


                          <label class="font-size-14px">{{EmbryoTransFerEndInfo.CultureMedia}}</label>
                        </div>




                      </div>
                      <div class="row">


                        <div class="col-md-6  text-align-right">
                          <label for="firstName" class="font-size-14px font-weight-700">Thawing Media Used </label>
                        </div>:
                        <div class="col-md-5 text-align-left" *ngIf="EmbryoTransFerEndInfo">


                          <label class="font-size-14px">{{EmbryoTransFerEndInfo.ThawingMedia}}</label>
                        </div>




                      </div>
                      <div class="row">
                        <div class="col-md-6 text-align-right">
                          <label for="firstName" class="font-size-14px font-weight-700">Endometrium Thickness </label>
                        </div>:
                        <div class="col-md-5 text-align-left" *ngIf="EmbryoTransFerEndInfo">
                          <label class="font-size-14px">{{EmbryoTransFerEndInfo.EndometriumThickness}}{{EmbryoTransFerEndInfo.EndometriumThicknessUnit}}</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 text-align-right">
                          <label for="firstName" class="font-size-14px font-weight-700">Method </label>
                        </div>:
                        <div class="col-md-5 text-align-left" *ngIf="EmbryoTransFerEndInfo">
                          <label class="font-size-14px">{{EmbryoTransFerEndInfo.TransferMethod}}</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 text-align-right">
                          <label for="firstName" class="font-size-14px font-weight-700">Catheter Type </label>
                        </div>:
                        <div class="col-md-5 text-align-left" *ngIf="EmbryoTransFerEndInfo">
                          <label class="font-size-14px">{{EmbryoTransFerEndInfo.CatheterType}}</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 text-align-right">
                          <label for="firstName" class="font-size-14px font-weight-700">Speculum Used</label>
                        </div>:
                        <div class="col-md-5 text-align-left" *ngIf="EmbryoTransFerEndInfo">
                          <label class="font-size-14px">{{EmbryoTransFerEndInfo.Speculum}}</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 text-align-right">
                          <label for="firstName" class="font-size-14px font-weight-700">Media Cleaning of Cervical Canal</label>
                        </div>:
                        <div class="col-md-5 text-align-left" *ngIf="EmbryoTransFerEndInfo">
                          <label class="font-size-14px">{{EmbryoTransFerEndInfo.CervicalCleaning}}</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6  text-align-right">
                          <label for="firstName" class="font-size-14px font-weight-700">Embryo Transfer </label>
                        </div>:
                        <div class="col-md-5 text-align-left" *ngIf="EmbryoTransFerEndInfo">


                          <label class="font-size-14px">{{EmbryoTransFerEndInfo.TransferType}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="row">


                        <div class="col-md-6  text-align-right">
                          <label for="firstName" class="font-size-14px font-weight-700">Day Of Transfer </label>
                        </div>:
                        <div class="col-md-5 text-align-left" *ngIf="EmbryoTransFerEndInfo">


                          <label class="font-size-14px">{{EmbryoTransFerEndInfo.DayOfTransfer}}</label>
                        </div>




                      </div>
                      <div class="row">
                        <div class="col-md-6 text-align-right">
                          <label for="firstName" class="font-size-14px font-weight-700">Retained Embryos </label>
                        </div>:
                        <div class="col-md-5 text-align-left" *ngIf="EmbryoTransFerEndInfo">
                          <label class="font-size-14px" *ngIf="EmbryoTransFerEndInfo.HasRetainedEmbryos">Present</label>
                          <label class="font-size-14px" *ngIf="!EmbryoTransFerEndInfo.HasRetainedEmbryos">Absent</label>
                        </div>
                      </div>
                      <!--<div class="row">
                <div class="col-md-6 text-align-right">
                  <label for="firstName" class="font-size-14px font-weight-700">Fragmentation </label>
                </div>:
                <div class="col-md-5 text-align-left" *ngIf="EmbryoTransFerEndInfo">
                  <label class="font-size-14px" *ngIf="EmbryoTransFerEndInfo.HasFragmentation">Present</label>
                  <label class="font-size-14px" *ngIf="!EmbryoTransFerEndInfo.HasFragmentation">Absent</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 text-align-right">
                  <label for="firstName" class="font-size-14px font-weight-700">Fragmentation(%) </label>
                </div>:
                <div class="col-md-5 text-align-left" *ngIf="EmbryoTransFerEndInfo">
                  <label class="font-size-14px">{{EmbryoTransFerEndInfo.Fragmentation}}</label>

                </div>
              </div>-->
                      <div class="row">
                        <div class="col-md-6 text-align-right">
                          <label for="firstName" class="font-size-14px font-weight-700">Catheter Used </label>
                        </div>:
                        <div class="col-md-5 text-align-left" *ngIf="EmbryoTransFerEndInfo">
                          <label class="font-size-14px">{{EmbryoTransFerEndInfo.Catheter}}</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 text-align-right">
                          <label for="firstName" class="font-size-14px font-weight-700">Cervical Mucus </label>
                        </div>:
                        <div class="col-md-5 text-align-left" *ngIf="EmbryoTransFerEndInfo">
                          <label class="font-size-14px" *ngIf="EmbryoTransFerEndInfo.CervicalMucus">Present</label>
                          <label class="font-size-14px" *ngIf="!EmbryoTransFerEndInfo.CervicalMucus">Absent</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 text-align-right">
                          <label for="firstName" class="font-size-14px font-weight-700">Technique </label>
                        </div>:
                        <div class="col-md-5 text-align-left" *ngIf="EmbryoTransFerEndInfo">
                          <label class="font-size-14px">{{EmbryoTransFerEndInfo.Technique}}</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 text-align-right">
                          <label for="firstName" class="font-size-14px font-weight-700">Blood on Catheter </label>
                        </div>:
                        <div class="col-md-5 text-align-left" *ngIf="EmbryoTransFerEndInfo">
                          <label class="font-size-14px" *ngIf="EmbryoTransFerEndInfo.BloodOnCatheter">Present</label>
                          <label class="font-size-14px" *ngIf="!EmbryoTransFerEndInfo.BloodOnCatheter">Absent</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 text-align-right">
                          <label for="firstName" class="font-size-14px font-weight-700">Retransfer </label>
                        </div>:
                        <div class="col-md-5 text-align-left" *ngIf="EmbryoTransFerEndInfo">
                          <label class="font-size-14px" *ngIf="EmbryoTransFerEndInfo.HasRetransfer">Done</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 text-align-right">
                          <label for="firstName" class="font-size-14px font-weight-700">Stilette </label>
                        </div>:
                        <div class="col-md-5 text-align-left" *ngIf="EmbryoTransFerEndInfo">
                          <label class="font-size-14px" *ngIf="EmbryoTransFerEndInfo.CervicalMucus">Present</label>
                          <label class="font-size-14px" *ngIf="!EmbryoTransFerEndInfo.CervicalMucus">Absent</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 text-align-right">
                          <label for="firstName" class="font-size-14px font-weight-700">Dilator </label>
                        </div>:
                        <div class="col-md-5 text-align-left" *ngIf="EmbryoTransFerEndInfo">
                          <label class="font-size-14px" *ngIf="EmbryoTransFerEndInfo.CervicalMucus">Present</label>
                          <label class="font-size-14px" *ngIf="!EmbryoTransFerEndInfo.CervicalMucus">Absent</label>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <!--<div class="col-md-4">
      <div class="card card-border-styles h-100">
        <div class="card-header wh-header header-new header-4 font-size-14">
          Procedure Details
        </div>
        <div class="card-body padding-top-0px padding-left-8px padding-bottom-0px">
          <div class="row">
            <div class="col-md-12 margin-top-5px">
              <label class="font-size-12px margin-bottom-0px">Needle Used</label>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="font-size-15px margin-bottom-0px">Double Lumen</label>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="font-size-12px margin-bottom-0px">Route</label>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="font-size-15px margin-bottom-0px font-weight-bold color-cyan">Tv</label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="font-size-12px margin-bottom-0px">Complications</label>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="font-size-15px margin-bottom-0px">Nill</label>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <label class="font-size-12px margin-bottom-0px">Batch</label>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="font-size-15px margin-bottom-0px">BNJ789</label>
            </div>
          </div>
        </div>
      </div>
    </div>-->
          </div>
          <div class="row margin-top-10">

          </div>
          <div class="row">
            <div class="col-md-12">
              <ivf-additional-detail [CycleCode]='CycleCode'
                                     Title="Additional Information"
                                     Context="EmbTrnAdnlDetail">
              </ivf-additional-detail>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>



